// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  txnId: __t.u64().primaryKey().name("txn_id"),
  identity: __t.identity(),
  bankId: __t.u64().name("bank_id"),
  kind: __t.string(),
  amount: __t.i64(),
  memo: __t.string(),
  at: __t.timestamp(),
});
